import { ActionTypes } from './types'

export default abstract class ActionNodeAction<T = unknown> {
  type!: ActionTypes

  /**
   * Если экшены будут расширяться,
   * в дочернем классе обязательно указать декоратор @Exclude()
   * Это не даст гуиду попасть в данные перед отправкой на сервер
   * пример:
   *   @Exclude()
   *   guid: string = Guid.create().toString()
   * */
  abstract guid: string

  abstract getNewModel(...args:any): T
}

export abstract class ActionNodeActionProxy {
  action!: ActionNodeAction

  abstract getModel(): ActionNodeAction

  isActionValid() {
    return true
  }
}

